import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { MAIN_COLOR } from 'containers/ChartPage/colors';
import { ErrorMessage } from 'utils/errors';
import { Card, Checkbox, Form, Grid, Message } from 'semantic-ui-react'; // main component
import { LayoutGrid, LayoutContainer } from 'utils/layouts';
import RegistrationModal from 'components/RegistrationModal';
import { ExpiredTokenPage } from 'containers/ErrorPage/ExpiredToken';
import {
  loginSuccesful,
  showLoader,
  hideLoader,
} from 'containers/TopPage/actions';
import request from 'utils/request';
import history from 'utils/history';
import {
  DEFAULT_REGISTRATION_FORM_PERSONAL_INFO_VALUES,
  DEFAULT_TREATMENT_HISTORY_FIELD_VALUES,
} from 'utils/defaults';
import { GENDER_OPTIONS } from 'utils/defaultOptions';
import InfertilityHistory from 'containers/RegistrationPage/forms/InfertilityHistory';
import PersonalInfo from 'containers/RegistrationPage/forms/PersonalInfo';

const RegistrationConfirmationPage = ({
  location,
  login,
  finishLoading,
  startLoading,
}) => {
  const cookies = new Cookies();
  const [pageErrorMessage, setPageErrorMessage] = useState('');
  const [hasTokenExpired, setShowErrorPage] = useState(undefined);
  const [
    registrationConfirmationToken,
    setRegisterConfirmationToken,
  ] = useState(null);
  const [termsAccepted, checkTerms] = useState(false);
  const [formStatus, setStatus] = useState([false, false, false, false, false]);
  const [formGroupValues, setFormGroupValues] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [errors, setErrors] = useState([]);
  const [personalInfoValues] = useState(
    DEFAULT_REGISTRATION_FORM_PERSONAL_INFO_VALUES,
  );
  const [treatmentHistoryValues] = useState(
    DEFAULT_TREATMENT_HISTORY_FIELD_VALUES,
  );
  const [userName, setUserName] = useState('');

  const validateForm = (index, newStatus) => {
    const newStatuses = formStatus.map(status => status);
    newStatuses[index] = newStatus;
    setStatus(newStatuses);
  };
  const updateFormValues = (index, newValues) => {
    const prevValues = JSON.parse(JSON.stringify(formGroupValues));
    prevValues[index] = newValues;
    setFormGroupValues(prevValues);
  };
  const uploadClosingState = newClosingState => {
    setModalOpen(newClosingState);
  };

  // here will be the api that will have the user
  const onRegisterUser = () => {
    startLoading({ value: true });
    const obj = { user: { ...formGroupValues } };
    obj.user.infertility_treatment_history.amh =
      obj.user.infertility_treatment_history.amh === ''
        ? null
        : obj.user.infertility_treatment_history.amh;
    const url = `${process.env.REACT_APP_API_URL}/api/v1/users`;
    const promise = request(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'Content-Type': 'application/json',
        charset: 'UTF-8',
        'X-Confirmation-Token': registrationConfirmationToken,
      },
    });
    promise.then(response => {
      if (response.errors) {
        setErrors(response.errors);
      } else {
        cookies.set('user_token', response.auth_token, { path: '/' });
        cookies.set('user_name', response.user.name, { path: '/' });
        cookies.set('user_id', response.user.id, { path: '/' });
        cookies.set('age_group', response.user.age_group, { path: '/' });
        login();
        history.push('/myData');
      }
      finishLoading({ value: true });
    });
  };
  useEffect(() => {
    const matches = location.search.match('/?token=(.*)');
    const token = matches && matches.length > 1 ? matches[1] : null;
    const url = `${process.env.REACT_APP_API_URL}/api/v1/email_confirmation/verify_token`;
    const promise = request(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        charset: 'UTF-8',
        'X-Confirmation-Token': token,
      },
    });
    promise.then(response => {
      if (!response.valid || !response) {
        setPageErrorMessage(
          response.errors && response.errors.length > 0
            ? response.errors[0]
            : 'エラー',
        );
        setShowErrorPage(true);
      } else {
        setUserName(response.name);
        setRegisterConfirmationToken(token);
        setShowErrorPage(false);
      }
    });
  }, [location]);
  if (hasTokenExpired !== undefined && hasTokenExpired) {
    finishLoading({ value: true });
    return (
      <ExpiredTokenPage
        errorMessage={pageErrorMessage}
        tokenType="registration"
      />
    );
  }
  if (hasTokenExpired === undefined) {
    startLoading({ loading: true });
  }
  if (hasTokenExpired !== undefined && !hasTokenExpired) {
    finishLoading({ value: true });

    return (
      <LayoutContainer style={{ marginTop: '70px', height: '100%' }}>
        <LayoutGrid>
          <Grid.Row columns={1}>
            <Grid.Column mobile={16} tablet={10} computer={10}>
              <Card
                style={{ width: '100%', paddingTop: 14 }}
                className="card__registration"
              >
                <Card.Content>
                  <Card.Header>
                    <h3
                      style={{
                        paddingLeft: 14,
                        paddingBottom: 14,
                        fontWeight: 500,
                      }}
                    >
                      治療歴・検査結果
                    </h3>
                  </Card.Header>
                  <Form error>
                    <PersonalInfo
                      isFormValid={validateForm}
                      defaultFormValues={personalInfoValues}
                      updateFormValues={updateFormValues}
                    />
                    <InfertilityHistory
                      isFormValid={validateForm}
                      defaultFormValues={treatmentHistoryValues}
                      updateFormValues={updateFormValues}
                    />
                    <div className="terms">
                      <Form.Field
                        label={
                          <label htmlFor="terms">
                            <a
                              href="https://dist.ninpath.com/tou.html"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="ninpath__form__terms__of__service"
                            >
                              利用規約
                            </a>
                            に同意する
                          </label>
                        }
                        checked={termsAccepted}
                        control={Checkbox}
                        style={{ textAlign: 'center' }}
                        onChange={(evt, { checked }) => {
                          checkTerms(checked);
                        }}
                      />
                    </div>

                    <div className="button_form_container">
                      <Form.Button
                        className="ninpath__form__container"
                        style={{ minWidth: '80px', maxWidth: '120px' }}
                        disabled={
                          !formStatus[0] || !formStatus[1] || !termsAccepted
                        }
                        onClick={() => {
                          setModalOpen(true);
                        }}
                      >
                        登録する
                      </Form.Button>
                      {(!formStatus[0] || !formStatus[1] || !termsAccepted) && (
                        <ErrorMessage color={MAIN_COLOR}>
                          必須項目が未入力の場合はボタンが押せません
                        </ErrorMessage>
                      )}

                      {errors.length > 0 && (
                        <Message negative>
                          <Message.Header>
                            登録できませんでした。
                          </Message.Header>
                          {errors.map(error => (
                            <p key={error}>{error}</p>
                          ))}
                        </Message>
                      )}
                      {formGroupValues.basic_information && (
                        <RegistrationModal
                          modalOpen={modalOpen}
                          name={userName}
                          sex={
                            GENDER_OPTIONS[
                              formGroupValues.basic_information.gender !== '' &&
                              formGroupValues.basic_information.gender !== null
                                ? formGroupValues.basic_information.gender
                                : 0
                            ].text
                          }
                          birthday={formGroupValues.basic_information.birthday}
                          uploadClosingState={uploadClosingState}
                          onRegisterUser={onRegisterUser}
                        />
                      )}
                    </div>
                  </Form>
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid.Row>
        </LayoutGrid>
      </LayoutContainer>
    );
  }
  return <div />;
};
const mapDispatchToProps = dispatch => ({
  login: () => dispatch(loginSuccesful()),
  startLoading: payload => dispatch(showLoader(payload)),
  finishLoading: payload => dispatch(hideLoader(payload)),
});

export default connect(
  null,
  mapDispatchToProps,
)(React.memo(withRouter(RegistrationConfirmationPage)));

RegistrationConfirmationPage.propTypes = {
  location: PropTypes.object.isRequired,
  login: PropTypes.any.isRequired,
  startLoading: PropTypes.func.isRequired,
  finishLoading: PropTypes.func.isRequired,
};
